// src/components/DashboardNav.jsx
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import useRestaurantContext from "../hooks/useRestaurantContext";

const MAIN_NAV_ITEMS = [
  {
    label: "Home",
    icon: "🏠",
    to: "/dashboard",
    highlight: true,
    end: true,
    requiresEmptySearch: true,
  },
  {
    label: "Orders",
    icon: "🧾",
    to: "/orders",
    highlight: true,
    end: true,
  },
  {
    label: "Menu",
    icon: "🍽️",
    to: "/menu/overview",
    highlight: true,
    end: false,
  },
  {
    label: "Reviews",
    icon: "👥",
    to: { pathname: "/dashboard", search: "?view=customers" },
    highlight: true,
    matchSearch: { key: "view", value: "customers", pathname: "/dashboard" },
  },
  {
    label: "Reports",
    icon: "📊",
    to: "/reports",
    highlight: false,
    end: false,
  },
  {
    label: "Payments",
    icon: "💳",
    to: "/payments",
    highlight: false,
    end: true,
  },
];

const BOTTOM_NAV_ITEMS = [
  { label: "Settings", icon: "⚙️", to: "/settings", highlight: true, end: true },
];

const normalize = (value) => String(value ?? "").trim().toLowerCase();

const DashboardNav = () => {
  const location = useLocation();
  const { restaurant, loading } = useRestaurantContext() || {};
  const isApproved = normalize(restaurant?.onboardingStatus) === "approved";

  const visibleMainNavItems = isApproved
    ? MAIN_NAV_ITEMS
    : MAIN_NAV_ITEMS.filter((item) => item.label !== "Payments");

  const visibleBottomNavItems = isApproved ? BOTTOM_NAV_ITEMS : [];

  const isCustomActive = (item, defaultIsActive) => {
    if (item.matchSearch) {
      const params = new URLSearchParams(location.search);
      return (
        location.pathname === item.matchSearch.pathname &&
        params.get(item.matchSearch.key) === item.matchSearch.value
      );
    }

    if (item.requiresEmptySearch && location.search) {
      return false;
    }

    return defaultIsActive;
  };

  const renderNavItems = (items) =>
    items.map((item) => (
      <NavLink
        key={item.label}
        to={item.to}
        end={item.end}
        className={({ isActive }) => {
          const active = isCustomActive(item, isActive);
          return `sidebar-item${active && item.highlight ? " active" : ""}`;
        }}
      >
        <span className="sidebar-icon" aria-hidden="true">
          {item.icon}
        </span>
        <span>{item.label}</span>
      </NavLink>
    ));

  return (
    <aside className="sidebar" style={{ display: "flex", flexDirection: "column" }}>
      <div className="sidebar-brand">
        <p className="sidebar-eyebrow">ManiDine</p>
        <h1>Manager</h1>
      </div>

      <nav className="sidebar-nav" style={{ display: "flex", flexDirection: "column", flex: 1 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
          {renderNavItems(visibleMainNavItems)}
        </div>

        <div style={{ marginTop: "auto", display: "flex", flexDirection: "column", gap: 0 }}>
          {renderNavItems(visibleBottomNavItems)}
        </div>
      </nav>
    </aside>
  );
};

export default DashboardNav;
